import { render, staticRenderFns } from "./DefaultDashboard.vue?vue&type=template&id=df48b27a&scoped=true&"
import script from "./DefaultDashboard.vue?vue&type=script&lang=js&"
export * from "./DefaultDashboard.vue?vue&type=script&lang=js&"
import style0 from "./DefaultDashboard.vue?vue&type=style&index=0&id=df48b27a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df48b27a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VRow,VSelect})
